// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { Component } from 'react'
import styled from 'styled-components'
import { NavLink, Navigate } from 'react-router-dom'
import moment from 'moment-timezone'
import Usage from './Usage'
import type { ContractType } from '../../../../store/index'
import { apiUrl } from '../../../../config/constants'
import MeteringPointYearSelector from "./MeteringPointYearSelector";

type Props = {
  contracts: Array<ContractType>,
  name: string,
  duration: number,
  type: string,
  icon: string,
  pathname: string,
  isIncoming?: boolean,
  isIncomingMessage?: string,
}

type State = {
  expanded: boolean,
  loading: boolean,
  contractsWithUsageData: Array<ContractType>,
  redirect: boolean,
  errorMessage: string,
  unit: string
  yearSelectorExpanded: boolean
}

class Product extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      expanded: false,
      yearSelectorExpanded: false,
      redirect: false,
      loading: true,
      errorMessage: '',
      contractsWithUsageData: [],
      unit: ""
    }

    this.getContracts = this.getContracts.bind(this)
  }

  componentDidMount = async (): Promise<void> => {
    this.getContracts()
  }

  getContracts = async (): Promise<void> => {
    const { contracts } = this.props
    this.setState({
      loading: true,
      errorMessage: '',
    })
    try {
      const contractsWithUsageData = await this.getContractsData(contracts)
      const filteredContracts = contractsWithUsageData.filter(
        value => value !== undefined
      )
      if (contractsWithUsageData.length === filteredContracts.length) {
        // remove duplicate contracts based on meteringpointIdentifier
        const uniqueContracts = Array.from(new Set(filteredContracts.map(contract => contract.meteringpointIdentifier))).map(id => filteredContracts.find(contract => contract.meteringpointIdentifier === id));
        this.setState({
          loading: false,
          contractsWithUsageData: uniqueContracts,
          errorMessage: '',
        })
      } else {
        this.setState({
          loading: false,
          contractsWithUsageData: [],
          errorMessage: 'Lataus epäonnistui',
        })
      }
    } catch (err) {
      this.setState({
        errorMessage: 'Yhteysvirhe kulutustietoja ladattaessa',
        loading: false,
      })
    }
  }

  // TODO Determine type.
  getContractsData = async (contracts: ContractType[]): Promise<ContractType[] | undefined> => {
    if (!contracts) {
      return
    }

    const result = Promise.all(
      contracts.map(async contract => {
        return this.getContract(contract)
      })
    )
    return result
  }

  getContract = async (contract: ContractType): Promise<ContractType[] | undefined> => {
    // Load contract data
    const data = await this.loadData(this.props.type, contract.meteringpointIdentifier)
    let sum = 0
    // var cumulative = undefined
    let timestampPeriod: string[] = []

    if (data) {
      const rawsum = data.map((d: { v: number }) => d.v).reduce((a: number, b: number) => a + b, 0)
      if (contract.utility === 'water') sum = +rawsum.toFixed(3)
      // kuutiot, kolmen desimaalin tarkkuudella
      else sum = Math.round(rawsum)

      if (data.length > 0) {
        const periodStart = moment(data[0].ts)
        const periodEnd = moment(data[data.length - 1].ts)
        if (data.length === 1) {
          periodEnd.endOf('month')
        }
        timestampPeriod = [
          periodStart.format('DD.MM.'),
          periodEnd.format('DD.MM.'),
        ]
      }

      data.forEach((_o, i, a) => {
        a[i].ts = moment(a[i].ts).format('DD.MM.')
      })
    } else {
      return
    }
    contract.usage = {
      data: data,
      period: timestampPeriod,
      periodType: '',
      usageSum: sum,
    }

    return contract
  }

  loadData = async (type, id): Array<DataPoint> | Promise<any> => { // eslint-disable-line
    let start = ''
    let end = ''
    let period = ''

    // Set API call period by usage type
    if (type === 'electricity') {
      period = 'thisyear'
    } else if (type === 'districtheat') {
      period = 'thisyear'
    } else if (type === 'water') {
      period = 'month'
    }

    // Set API call date format by usage period
    if (period === 'day' || period === 'hour') {
      start = moment()
        .startOf('year')
        .format('YYYY-MM-DD')
      end = moment().format('YYYY-MM-DD')
    } else if (period === 'month') {
      start = moment()
        .startOf('year')
        .format('YYYY-MM')
      end = moment().format('YYYY-MM')
    }

    if (type === 'districtheat') {
      type = 'heat'
    }

    const req = new Request(
      `${apiUrl}/${type}/${period}?start=${start}&end=${end}&mp=${id}&companyid=`,
      {
        method: 'GET',
        mode: 'cors',
      }
    )

    let response
    let responseData
    try {
      response = await fetch(req)
      if (response.status === 401) {
        return
      } else if (response.ok) {
        responseData = await response.json()
        const { data, unit } = responseData
        this.setState({ unit: unit });
        return data
      } else {
        return
      }
    } catch (error) {
      throw error
    }
  }

  expand = (): void => {
    const { expanded, errorMessage, contractsWithUsageData } = this.state
  
    if (contractsWithUsageData.length > 0) {
      if (contractsWithUsageData.length > 1) {
        this.setState({ expanded: !expanded })
      } else if (!errorMessage) {
        this.setState({ redirect: true })
      }
    }
  }

  toggleYearSelector = (): void => {
    this.setState(prevState => ({
      yearSelectorExpanded: !prevState.yearSelectorExpanded
    }));
  };
  

  getUsagePlaces = (
    contracts: Array<Contract>,
    pathname: string,
  ): any => { // eslint-disable-line
    if (contracts !== null) {
      if (contracts.length > 1) {
        // TODO Determine type.
        const usagePlaces = contracts.map<any>((contract, i) => { // eslint-disable-line
          return (
            <NavLink
              key={i}
              className="list-item"
              to={`/` + pathname + `/${contract.meteringpointIdentifier}`}
            >
              <div key={i} className="info-row">
                <div className="info-street">
                  <p>
                    {contract.address}
                    <br />
                    {contract.zip}, {contract.city}
                  </p>
                  <p />
                </div>
                <div className="info-usage">
                  <p>
                    {contract.usage.usageSum}
                    <span>{this.state.unit}</span>
                  </p>
                </div>
                <div className="info-arrow">
                  <i className="fa fa-chevron-right" aria-hidden="true" />
                </div>
              </div>
            </NavLink>
          )
        })
        return usagePlaces
      }
    }
  }

  render(): JSX.Element {
    const {
      name,
      type,
      icon,
      contracts,
      duration,
      pathname,
      isIncoming,
      isIncomingMessage,
    } = this.props
    const {
      redirect,
      yearSelectorExpanded,
      expanded,
      loading,
      contractsWithUsageData,
      errorMessage,
      unit
    } = this.state

    const usagePlaces = this.getUsagePlaces(
      contractsWithUsageData,
      pathname
    )
    const currentYear = moment().format("YYYY");
    const period =
      contractsWithUsageData &&
      contractsWithUsageData.length > 0 &&
      contractsWithUsageData[0].usage &&
      `${contracts[0].usage.period[0]} - ${contracts[0].usage.period[1]}`

    let height = ''
    if (contractsWithUsageData !== null) {
      height = `${58 * contractsWithUsageData.length}px`
    }

    if (redirect) {
      const url = `/${pathname}/${contractsWithUsageData[0].meteringpointIdentifier}`
      return <Navigate to={url} />
    }

    if (isIncoming) {
      return (
        <div className={`${type} incoming`}>
          <div className="top-wrapper noselect" onClick={this.expand}>
            <div className="left">
              <div className="icon">
                <img src={icon} alt={name} />
              </div>
            </div>
            <div className="right">
              <IncomingServiceMessage>
                {isIncomingMessage}
              </IncomingServiceMessage>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className={`${type}${expanded ? ' expanded' : ''}`}>
        <div className="top-wrapper noselect" onClick={this.expand}>
          <div className="left">
            <div className="icon">
              <img src={icon} alt={name} />
            </div>
          </div>
          {loading && (
            <MessageWrapper>
              <LoadingElement>Ladataan lukemia vuodelle {currentYear}</LoadingElement>
            </MessageWrapper>
          )}
          {errorMessage && (
            <MessageWrapper>
              <ErrorMessageElement>{errorMessage} vuodelle {currentYear}</ErrorMessageElement>
              <ReloadButton onClick={this.getContracts}>
                Yritä uudestaan
              </ReloadButton>
            </MessageWrapper>
          )}
          {!loading && !errorMessage && contractsWithUsageData.length > 0 && (
            <Usage
              usageSum={contractsWithUsageData[0].usage.usageSum}
              unit={unit}
              duration={duration}
              name={name}
              type={type}
              period={period}
              address={contractsWithUsageData[0].address}
              zip={contractsWithUsageData[0].zip}
              city={contractsWithUsageData[0].city}
            />
          )}
        </div>

        <div
          className="more-info"
          style={{ height: `${expanded ? height : '0px'}` }}
        >
          {usagePlaces}
        </div>
        {errorMessage && (
          <YearSelectorToggle>
            <ToggleButton onClick={this.toggleYearSelector}>
              Avaa vuosivalinta mahdollisuus
            </ToggleButton>
          </YearSelectorToggle>
        )}
        {( yearSelectorExpanded) && (
          <MeteringPointYearSelector contracts={contracts} pathname={pathname} failedYear={currentYear} />
        )}
      </div>
    )
  }
}

export default Product

const IncomingServiceMessage = styled.h1`
  color: #fff;
  font-size: 24px;
  text-align: center;
  padding: 5px;
  &&& {
    margin: 0;
  }
`

const LoadingElement = styled.h1`
  font-size: 25px;
  color: #fff;
  padding-top: 55px;
  text-align: center;
  padding: 0;
  &&& {
    margin: 0;
  }
`

const ErrorMessageElement = styled(LoadingElement)`
  &&& {
    font-size: 25px;
    margin-bottom: 20px;
  }
`

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: calc(100% - 160px);
`

const ReloadButton = styled.button`
  color: #fff;
  width: auto;
  border: 1px solid #fff;
  border-radius: 3px;
  cursor: pointer;
  height: 40px;

  &:hover {
    color: #0074bc;
    background-color: #fff;
  }
`

const YearSelectorToggle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

const ToggleButton = styled.button`
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;
